import PremiumProductCard from './PremiumProductCard'
import { ProductDialog } from 'components'

const DefaultProductView = ({
  product,
  finalPrice,
  layout,
  quickView,
  isDialogOpen,
  handleQuickView,
  addToFavourites,
  removeFromFavourites,
  isFavourite,
  navigate,
  handleAdd,
  handleRemove,
  getQuantity,
  itemIds,
}) => {
  const inCart = itemIds.includes(product._id)
  const qty    = getQuantity(product._id)

  return (
    <>
      <PremiumProductCard
        product={product}
        finalPrice={finalPrice}
        layout={layout}
        quickView={quickView}
        inCart={inCart}
        cartQty={qty}
        isFav={isFavourite(product._id)}
        onNavigate={() => navigate(`/products/${product.slug || product._id}`)}
        onQuickView={handleQuickView}
        onAddToCart={handleAdd}
        onRemoveFromCart={handleRemove}
        onToggleWishlist={() =>
          isFavourite(product._id)
            ? removeFromFavourites(product._id)
            : addToFavourites(product)
        }
      />

      {isDialogOpen && (
        <ProductDialog
          isDialogOpened={isDialogOpen}
          thumbnail={product.thumbnail}
          productId={product._id}
          handleCloseDialog={handleQuickView}
        />
      )}
    </>
  )
}

export default DefaultProductView
